import { Page } from '../pages/policy/cookies-privacy-policy';

export default function () {
  return (
    <Page />
  );
};
